import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';

const { white, formBackground, gray } = Colors;
export const Wrapper = styled.div`
    max-width: 400px;
    background: white;
    border-radius: 5px;
    padding: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h4`
    text-align: center;
    margin-bottom: 24px;
`;

export const CountryCardWrapper = styled.div`
    background: #f3f0ff;
    border-radius: 5px;
    padding: 14px;
    // margin-bottom: 24px;
`;

export const CountryHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    justify-content: center;
`;

export const Flag = styled.span`
    font-size: 24px;
    margin-right: 10px;
`;

export const CountryName = styled.h2`
    font-size: 20px;
    font-weight: 600;
`;

export const StreamItemWrapper = styled.div`
    background: #fff;
    border-radius: 5px;
    padding: 16px;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
`;

export const StreamTitleGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StreamHeader = styled.p`
    color: #999;
    font-size: 12px;
    margin: 0;
`;

export const StreamTitle = styled.p`
    font-size: 14px;
    font-weight: 600;
    margin: 2px 0 0 0;
`;

export const ScoreBadge = styled.span<{ score: number }>`
    background-color: ${({ score }) =>
        score >= 80 ? '#4CAF50' : score >= 50 ? '#FFA726' : '#EF5350'};
    color: white;
    padding: 6px 12px;
    border-radius: 5px;
    font-weight: bold;
`;

export const SideBarCollectionHeader = styled.div`
    ${TextStyle({ fontSize: '22px', fontWeight: '600' })}
    display: flex;
    gap: 15px;
    font-style: normal;
    line-height: 27px;
    text-transform: capitalize;
`;

export const CollectionItemHeader = styled.div`
    ${TextStyle({ fontSize: '12px', fontWeight: '500', color: gray })}
    font-style: normal;
    line-height: 15px;
    text-transform: capitalize;
`;

export const CollectionItemText = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '500' })}
    font-style: normal;
    line-height: 18px;
    text-transform: capitalize;
`;

export const CollectionItemBadge = styled.div`
    ${TextStyle({ fontSize: '14px', fontWeight: '600', color: white })}
    border-radius: 4px;
    width: 45.12px;
    min-width: 45.12px;
    height: 25px;
    font-style: normal;
    line-height: 17px;
    text-align: center;
    text-transform: capitalize;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CollectionItemBody = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const SideBarCollectionItem = styled.div`
    background: ${formBackground};
    border-radius: 3px;
    padding: 12px 16px 10px;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
`;
